import { render, staticRenderFns } from "./InicioAdmin.vue?vue&type=template&id=3394f9cf&"
import script from "./InicioAdmin.vue?vue&type=script&lang=js&"
export * from "./InicioAdmin.vue?vue&type=script&lang=js&"
import style0 from "./InicioAdmin.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports